/* eslint-disable react/no-danger */

import React, { PropTypes } from 'react'
import LibCheckbox from 'react-toolbox/lib/checkbox'
import classnames from 'classnames'
import theme from './Checkbox.scss'
import styles from 'components/Form/Form.scss'

const Checkbox = (props) => {
  const {
    disabled,
    handleChange,
    label,
    name,
    checked,
    className,
    error,
  } = props

  const _handleChange = (value, e) => {
    handleChange(name, e.target.checked)
  }

  const spanLabel = <span dangerouslySetInnerHTML={{ __html: label }} />

  return (
    <div>
      <LibCheckbox
        checked={checked}
        className={className}
        disabled={disabled}
        label={spanLabel}
        name={name}
        onChange={_handleChange}
        theme={theme}
      />
      {
      error &&
      <span className={classnames(styles.error)}>{error}</span>
    }
    </div>
  )
}

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
}

Checkbox.defaultProps = {
  disabled: false,
  checked: false,
  className: null,
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Form/components/Checkbox/Checkbox.js